var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.083,
    height: 25.022,
    viewBox: "0 0 25.083 25.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "address",
    d: "M10.019,22.468v2.54l-.614-.5a41.183,41.183,0,0,1-4.643-4.54C1.6,16.345,0,13.089,0,10.3v-.277a10.019,10.019,0,0,1,20.037,0V10.3c0,.235-.012.473-.035.714L18.043,9.222a8.064,8.064,0,0,0-16.088.8V10.3C1.955,15.017,8.038,20.732,10.019,22.468Zm6.011-1.4h2.932V18.131H16.03Zm-6.011-15.2a4.154,4.154,0,1,1-4.154,4.154A4.159,4.159,0,0,1,10.019,5.865Zm0,1.955a2.2,2.2,0,1,0,2.2,2.2A2.2,2.2,0,0,0,10.019,7.819ZM23.766,19.735l-.55-.5v3.138a2.653,2.653,0,0,1-2.65,2.65H14.377a2.653,2.653,0,0,1-2.65-2.65V19.234l-.55.5L9.86,18.291l7.612-6.944,7.612,6.944Zm-2.5-2.285-3.79-3.458-3.79,3.458v4.922a.7.7,0,0,0,.7.7h6.189a.7.7,0,0,0,.7-.7Zm0,0",
    fill: "#ff3414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.6bf8f0390bf4f3f7a8201e6ee6eb513f.svg";
export { ForwardRef as ReactComponent };